import React from "react";
import "./background-space.css";
import background from '../../images/profile/torre-david.jpg'

const BackgroundSpace =()=> {
  return (
    <div className="background-space">
      <img className="image-background-space" src={background} alt="Johadry Perez Web Developer | Front End" />
    </div>
  );
}

export default BackgroundSpace;